var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJaanuuLogo20241(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 14,
    viewBox: "0 0 79 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_7877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74421 14C1.82367 13.9777 0.905988 13.8594 0 13.6463L0 9.40456C0.342081 9.46351 1.27761 9.68702 1.61969 9.68702C2.72342 9.68702 3.9689 9.82456 3.9689 7.84246V0H7.9378V8.81754C7.9378 12.7277 5.38825 14 2.74421 14Z",
    fill: "#0A0B09"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5547 0H42.4933L47.7852 8.26246V6.09368V0H51.2174V14H47.5017L42.002 5.69825V7.84737V14H38.5547V0Z",
    fill: "#0A0B09"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3323 0V6.98035C56.3323 8.98456 57.1771 10.2421 58.8799 10.2421C60.4788 10.2421 61.4125 8.96491 61.4125 6.98035V0H65.2037V7.57228C65.2037 11.4825 62.9679 14 58.8799 14C54.792 14 52.541 11.4432 52.541 7.51579V0H56.3323Z",
    fill: "#0A0B09"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1291 0V6.98035C70.1291 8.98456 70.9739 10.2421 72.6768 10.2421C74.2757 10.2421 75.2093 8.96491 75.2093 6.98035V0H79.0006V7.57228C79.0006 11.4825 76.7648 14 72.6768 14C68.5888 14 66.3379 11.4432 66.3379 7.51579V0H70.1291Z",
    fill: "#0A0B09"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.559 8.45649C16.559 8.45649 15.236 4.03544 15.047 3.16351H15.0017C14.8259 4.04526 13.4897 8.45649 13.4897 8.45649H16.559ZM12.5939 0H17.4548L22.3007 14H18.277L17.47 11.394H12.5788L11.7718 14H7.74805L12.5939 0Z",
    fill: "#0A0B09"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8676 8.41474C31.8676 8.41474 30.5446 3.97158 30.3556 3.08246H30.3103C30.0608 4.00596 28.7983 8.41474 28.7983 8.41474H31.8676ZM27.9025 0H32.7634L37.6093 14H33.5856L32.7786 11.3916H27.8874L27.0803 14H23.0566L27.9025 0Z",
    fill: "#0A0B09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_7877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaanuuLogo20241);
export default __webpack_public_path__ + "static/media/jaanuu-logo-2024 1.f4c034409d159caa214e758ba0130e06.svg";
export { ForwardRef as ReactComponent };